class InvoiceFormModalService extends BaseService
	@register()
	@inject 'OrderRepository',
		'BACKEND_TRANSACTION_PAYMENT_TYPE'

	createDatePickerConfig: (options = {}) ->
		config =
			singleDatePicker: true
			minDate: moment()
		_.extend config, options

	createIntervalDatePickerConfig: ->
		timePicker: false
		maxDate: moment()

	filterInvoiceStatuses: (statuses, excludeIds = []) ->
		_.reject statuses, (status) -> status.id in excludeIds

	findOrders: (search, customerId, excludeOrderIds, invoiceType) ->
		query = @OrderRepository.createQuery()
		query.with 'transactions'
		query.criteria 'id', 'LIKE', "%#{search}%"
		query.criteria 'is_paid', '=', '1'
		query.criteria 'transactions>type', '=', invoiceType
		query.criteria 'transactions>invoice_id', 'IS', 'NULL'

		if customerId
			query.criteria 'customer_id', '=', customerId

		if !_.isEmpty excludeOrderIds
			query.criteria 'id', 'NOT IN', excludeOrderIds.join(',')

		query.setPagination 0, 10

		return @OrderRepository.findByQuery query

	extractOrdersFromInvoice: (invoice) ->
		orders = []

		for transaction in invoice.transactions || []
			orders.push
				id: transaction.order_id
				transactions: [{ id: transaction.id }]

		return orders

	prepareInvoiceBaseData: ->
		status: null
		issue_date: moment().unix()
		due_date: null
		invoice_number: null
		currency: null
		customer_id: null
